import React from "react";
import { constants } from "../modules/redux-acron";
import { call, put, all } from "redux-saga/effects";
import Loading from "../components/Loading";
import Error from "../components/Error";
import initialState from "../utils/initialState";

export const camelCaseIt = string =>
  string
    .toLowerCase()
    .trim()
    .split(/[.\-_\s]/g)
    .reduce((string, word) => string + word[0].toUpperCase() + word.slice(1));

export const getComponent = (
  loading = false,
  error = null,
  data = null,
  component,
  emptyText
) => {
  if (loading) {
    return <Loading />;
  } else if (error) {
    return <Error reason={error} />;
  } else if (
    data === undefined ||
    data === null ||
    data.length === 0 ||
    (data &&
      typeof data[0] === "object" &&
      Object.getOwnPropertyNames(data[0]).length === 0) ||
    (Array.isArray(data[0]) &&
      (data[0][0] === null || data[0][0] === undefined))
  ) {
    return (
      <span className="no-data">
        {emptyText || "Sin información para mostrar"}
      </span>
    );
  }
  return component;
};

export const handleFilters = (
  value,
  name,
  filters,
  updateFilters,
  clearErrors
) => {
  const newFilters = { ...filters, [name]: value };
  if (clearErrors) {
    clearErrors();
  }
  updateFilters(newFilters);
};
export const handlerWrapper = (name, state, status, payload) => {
  const currentRoute = window.location.pathname.split("/")[1];
  if (status === constants.PENDING_STATUS) {
    return state.merge({
      loading: true,
      [name]: initialState[currentRoute]
        ? initialState[currentRoute][name]
        : initialState.dashboard[name]
    });
  }

  if (status === constants.SUCCESS_STATUS) {
    return state.merge({
      loading: false,
      [name]: payload.data,
      loadingData: { ...state.loadingData, [name]: true }
    });
  }
  return state.merge({
    loading: false,
    error: { ...state.error, [name]: payload.data.error }
  });
};

export const handlerWrapperSingleton = (name, state, status, payload) => {
  const currentRoute = window.location.pathname.split("/")[1];
  if (status === constants.PENDING_STATUS) {
    return state.merge({
      loading: true,
      [name]: initialState[currentRoute]
        ? initialState[currentRoute][name]
        : initialState.dashboard[name]
    });
  }

  if (status === constants.SUCCESS_STATUS) {
    return state.merge({
      loading: false,
      [name]: payload.data[0],
      loadingData: { ...state.loadingData, [name]: true }
    });
  }
  return state.merge({
    loading: false,
    error: { ...state.error, [name]: payload.data.error }
  });
};

export function* handlerEffects(apiCall, filters, func) {
  const response = yield call(apiCall, filters);
  if (response.ok) {
    yield put(
      func(
        {
          data: response.data
        },
        constants.SUCCESS_STATUS
      )
    );
  } else {
    yield put(
      func({ data: { error: response.problem } }, constants.FAILURE_STATUS)
    );
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js